import React from 'react';

import { Sailing } from '../../shared/types/sailing';
import { getLocaleDateStringUTC } from '../../shared/lib/time';
import { SailingTemplate } from '../../shared/types/template';
import {
  TabPanel,
  TabContent,
  RadioButtonGroup,
  RadioButton,
  Button,
} from '@spark-labs/avocado-ui';

export interface SailingTemplateFormProps {
  sailing: Sailing;
  sailingTemplates: SailingTemplate[];
  onSubmit?: (sailing: Sailing, template: SailingTemplate) => void;
}

export interface SailingTemplateFormState {
  selectedTab: number;
  selectedTemplate?: SailingTemplate;
}

export default class SailingTemplateForm extends React.Component<
  SailingTemplateFormProps,
  SailingTemplateFormState
> {
  public readonly state: SailingTemplateFormState = { selectedTab: 0 };

  constructor(props: SailingTemplateFormProps) {
    super(props);

    this.handleSelectedTab = this.handleSelectedTab.bind(this);
    this.handleTemplateSelect = this.handleTemplateSelect.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  public render() {
    let setTemplates = this.props.sailingTemplates.filter(t => t.type === 'project');
    let goTemplates = this.props.sailingTemplates.filter(t => t.type === 'sailing');

    return (
      <div className="border-t border-grey pt-2 p-4 mt-6" style={{ width: '600px' }}>
        <div className="text-xl text-teal-darker">
          <span>Days: </span>
          <span className="font-bold text-2xl mx-1">{this.props.sailing.days.length}</span>
          <span className="mx-4">|</span>
          {this.props.sailing.days.length > 0 && (
            <>
              <span>Starting Date: </span>
              <span className="font-bold text-2xl mx-1">
                {getLocaleDateStringUTC(this.props.sailing.days[0].date)}
              </span>
            </>
          )}
        </div>
        <TabPanel selectedTab={this.state.selectedTab} onTabChange={this.handleSelectedTab}>
          <TabContent title="SET Projects">
            <div className="p-4">
              <RadioButtonGroup
                name="templates"
                onChange={this.handleTemplateSelect}
                groupValue={
                  this.state.selectedTemplate ? this.state.selectedTemplate._id : undefined
                }
              >
                {groupProps => (
                  <ul>
                    {setTemplates.map(template => (
                      <li className="my-1" key={template._id}>
                        <RadioButton
                          value={template._id}
                          label={template.name}
                          checked={groupProps.groupValue === template._id}
                          {...groupProps}
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </RadioButtonGroup>
            </div>
          </TabContent>
          <TabContent title="GO Favorite Sailings">
            <div className="p-4">
              <RadioButtonGroup
                name="templates"
                onChange={this.handleTemplateSelect}
                groupValue={
                  this.state.selectedTemplate ? this.state.selectedTemplate._id : undefined
                }
              >
                {groupProps => (
                  <ul>
                    {goTemplates.map(template => (
                      <li className="my-1" key={template._id}>
                        <RadioButton
                          value={template._id}
                          label={template.name}
                          checked={groupProps.groupValue === template._id}
                          {...groupProps}
                        />
                      </li>
                    ))}
                  </ul>
                )}
              </RadioButtonGroup>
            </div>
          </TabContent>
        </TabPanel>
        <div className="mt-4 flex justify-end">
          <div className="mx-2">
            <Button
              color="green"
              onClick={this.handleFormSubmit}
              disabled={!this.state.selectedTemplate}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    );
  }

  private handleSelectedTab(tabIndex: number) {
    this.setState({ selectedTab: tabIndex });
  }

  private handleTemplateSelect(templateId: string) {
    let selectedTemplate = this.props.sailingTemplates.find(
      template => template._id === templateId
    );
    if (!selectedTemplate) {
      console.error(`Could not find template ${templateId}`);
      return;
    }

    this.setState({ selectedTemplate });
  }

  private handleFormSubmit() {
    if (!this.state.selectedTemplate || !this.props.onSubmit) return;
    this.props.onSubmit(this.props.sailing, this.state.selectedTemplate);
  }
}
